import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CancelIcon from '@mui/icons-material/Cancel';
import type { SvgIconComponent } from '@mui/icons-material';
import {
  GoalStatus,
  MilestoneStatus,
  getGoalStatusLabel,
  getGoalStatusColor
} from '../circles-page/constants';

export { GoalStatus, MilestoneStatus, getGoalStatusLabel, getGoalStatusColor };

export enum GoalType {
  Learning = 0,
  Performance = 1
}

export enum SubmissionReviewStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2
}

export function getGoalTypeLabel(type: GoalType): string {
  switch (type) {
    case GoalType.Learning:
      return 'circle_details.goal_type_learning';
    case GoalType.Performance:
      return 'circle_details.goal_type_performance';
    default:
      return 'circle_details.goal_type_learning';
  }
}

export function getGoalTypeColor(type: GoalType): 'primary' | 'secondary' {
  switch (type) {
    case GoalType.Performance:
      return 'secondary';
    default:
      return 'primary';
  }
}

/**
 * Get MUI color for milestone status
 */
export function getMilestoneStatusColor(
  status: MilestoneStatus
): 'success' | 'primary' | 'warning' | 'error' | 'default' {
  switch (status) {
    case MilestoneStatus.Completed:
      return 'success';
    case MilestoneStatus.InProgress:
      return 'primary';
    case MilestoneStatus.NotStarted:
      return 'default';
    case MilestoneStatus.Cancelled:
      return 'error';
    default:
      return 'default';
  }
}

/**
 * Get icon component for goal status
 */
export function getGoalStatusIcon(status: GoalStatus): SvgIconComponent {
  switch (status) {
    case GoalStatus.NotStarted:
      return PauseIcon;
    case GoalStatus.InProgress:
      return PlayArrowIcon;
    case GoalStatus.Completed:
      return CheckCircleIcon;
    case GoalStatus.Cancelled:
      return CancelIcon;
    default:
      return PauseIcon;
  }
}

/**
 * All available goal statuses for selection, with translated labels.
 * Pass the `translate` function from `useLocales` to get localised labels.
 */
export function getGoalStatusOptions(
  translate: (key: string) => string
): { value: GoalStatus; label: string }[] {
  return [
    { value: GoalStatus.NotStarted, label: translate(getGoalStatusLabel(GoalStatus.NotStarted)) },
    { value: GoalStatus.InProgress, label: translate(getGoalStatusLabel(GoalStatus.InProgress)) },
    { value: GoalStatus.Completed, label: translate(getGoalStatusLabel(GoalStatus.Completed)) },
    { value: GoalStatus.Cancelled, label: translate(getGoalStatusLabel(GoalStatus.Cancelled)) }
  ];
}
